import create from "zustand";

interface RegisterBusinessModalState {
  isOpen: boolean;
}

interface RegisterBusinessModalActions {
  onOpen: () => void;
  onClose: () => void;
}

const useRegisterModalBusiness = create<RegisterBusinessModalState & RegisterBusinessModalActions>(
  (set) => ({
    isOpen: false,
    onOpen: () => set({ isOpen: true }),
    onClose: () => set({ isOpen: false }),
  })
);

export default useRegisterModalBusiness;
